
import { Injectable, Inject} from '@angular/core';
import {BaseDO} from './base.model';



 export  class IntimationStagingDocumentDO extends BaseDO {

    public id:Number=null;
    public  documentTypeCd:string=null;
    public  documentSubTypeCd:string=null;
    public  visibilityCd:string=null;
    public  imageURL:string=null;
    public  uploadStatus:string=null;
    public  documentCd:string=null;
    public   entityImageName:string=null;
    public  requirement:string=null;
    public   documentRecievedDt:Date= null;
   
}